export class Logging {
    private readonly label: string;
    private readonly css: string;

    constructor(label: string, css: string) {
        this.label = label.toLocaleUpperCase();
        this.css = css;
    }

    public info(...args: unknown[]) {
        console.info(`%c ${this.label}: `, this.css, ...args);
    }

    public warn(...args: unknown[]) {
        console.warn(`%c ${this.label}: `, this.css, ...args);
    }

    public error(...args: unknown[]) {
        console.error(`%c ${this.label}: `, this.css, ...args);
    }

    /**
     * Function for logging out lots of tracing information during development
     */
    static trace(...args: unknown[]) {
        console.log('%c Trace: ', 'background: #676767; color: white;', ...args);
    }
}
